import { LiliTransaction } from '../types/lili-transaction';
import { TransactionStatus } from '../enum/transaction-status';
import { ExternalTransactionTypes } from '../enum/extranal-transaction-types';
import { TransactionCategorizationType } from '../enum/transaction-categorization-type';
import { TransactionCheckStatus } from '../enum/transaction-check-status';

export const mockLoadingTable = new Array(20).fill({
  creditCard: false,
  activityTypeCode: 'AD',
  amount: -24,
  merchantName: '',
  currencyCode: 'USD',
  timestamp: '2024-01-29T18:00:08.000Z',
  transactionId: '392775_478695_AD',
  pending: false,
  type: 'M',
  sourceId: '478695',
  localCurrencyCode: 'USD',
  settleCurrencyCode: 'USD',
  billingCurrencyCode: 'USD',
  allowCategorizationEnum: 'FORBIDDEN',
  categoryDetails: {},
  details: 'Savings for emergency',
  bucketAccountId: '393109',
  trxType: 'EMERGENCY_BUCKET',
  trxTypeParams: 'EMERGENCY_BUCKET_AUTO',
  allowComment: true,
  onHold: false,
  transactionStatus: 'SETTLED',
  externalTransactionType: 'EMERGENCY_BUCKET_AUTO_SAVE',
});

export const TRANSACTIONS: LiliTransaction[] = [
  {
    creditCard: true,
    activityTypeCode: 'VI',
    amount: -163,
    merchantName: 'Tesla Black Tap Soho New York',
    currencyCode: 'USD',
    timestamp: '2024-02-11T09:27:11.000Z',
    transactionId: '631967_ec62f725-480b-47c3-8ee5-8fcf04eef201_VS',
    pending: true,
    type: 'A',
    mccCode: '7542',
    sourceId: 'ec62f725-480b-47c3-8ee5-8fcf04eef201',
    localAmount: 2500,
    localCurrencyCode: 'INR',
    settleCurrencyCode: 'USD',
    billingAmount: 163,
    billingCurrencyCode: 'USD',
    allowCategorizationEnum: 'READ_WRITE',
    locationKey: 'Tesla Black Tap Soho New York',
    locationDetails: {
      locationKey: 'Tesla Black Tap Soho New York',
      name: 'Tesla Black Tap Soho New York',
      address: '529 Broome St, New York, NY 10013, USA',
      phoneNumber: '+1 917-639-3089',
      icon: 'https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/restaurant-71.png',
      website: 'https://blacktap.com/location/soho/',
      type: [
        'restaurant',
        'food',
        'point_of_interest',
        'establishment',
      ],
      approved: true,
      latitude: 40.7238388,
      longitude: -74.0041755,
    },
    categoryDetails: {
      businessPercent: 0.8,
      categoryExternalId: '67F37CE9-74E3-1250-2AE5-1E902CF85D78',
    },
    suggestedTaxCategoryId: '1BCC71DC-0625-A776-A1E6-7F190F895AB3',
    trxType: 'UNKNOW',
    trxTypeParams: 'NONE',
    comment: 'Comment about swipe Expense with All Data',
    allowComment: true,
    onHold: false,
    transactionStatus: TransactionStatus.PENDING,
    externalTransactionType: ExternalTransactionTypes.SWIPE,
    categorizationType: TransactionCategorizationType.EXPENSE,
    initiatorPan: '3213',
    initiatorFirstName: 'Jasen',
    initiatorLastName: 'Mayer',
    /** Check details mock data */
    // checkDetailsData: {
    //   checkTransactionId: 'ef52e66c-9601-4ab4-abfe-e9cc73733a1f',
    //   estimatedArrivalDate: '2024-02-05T17:00:00.000+00:00',
    //   checkNumber: '003556177',
    // },
    /** Transfer details mock data */
    expectedClearDate: new Date().toISOString(),
    sourceRoutingNumber: '123456',
    sourceAchNumber: '654321',
    targetRoutingNumber: '111111',
    targetAchNumber: '444444',
  },
  {
    creditCard: true,
    activityTypeCode: 'VS',
    amount: 97,
    merchantName: 'Koelpin and Sons',
    currencyCode: 'USD',
    timestamp: '2024-02-10T01:37:33.000Z',
    transactionId: '631967_9dd2519f-e4c5-4ad1-b24e-688e5e2277d3_VS',
    pending: false,
    type: 'Z',
    sourceId: '9dd2519f-e4c5-4ad1-b24e-688e5e2277d3',
    localAmount: 552,
    localCurrencyCode: 'ILS',
    settleCurrencyCode: 'USD',
    billingCurrencyCode: 'USD',
    allowCategorizationEnum: 'FORBIDDEN',
    locationKey: 'Koelpin and Sons',
    locationDetails: {
      locationKey: 'Koelpin and Sons',
      name: 'Koelpin and Sons',
      type: [],
      latitude: 0,
      longitude: 0,
    },
    categoryDetails: {},
    details: 'Koelpin and Sons',
    trxType: 'UNKNOW',
    trxTypeParams: 'NONE',
    allowComment: true,
    onHold: false,
    transactionStatus: TransactionStatus.SETTLED,
    externalTransactionType: ExternalTransactionTypes.SWIPE_REFUND,
    categorizationType: TransactionCategorizationType.INCOME,
  },
  {
    creditCard: true,
    activityTypeCode: 'VS',
    amount: 218,
    merchantName: 'Baumbach-Baumbach',
    currencyCode: 'USD',
    timestamp: '2024-02-09T14:10:57.000Z',
    transactionId: '631967_2a0530c5-9c6b-4750-8b38-ef799cfac433_VS',
    pending: false,
    type: 'Z',
    sourceId: '2a0530c5-9c6b-4750-8b38-ef799cfac433',
    localAmount: 552,
    localCurrencyCode: 'ILS',
    settleCurrencyCode: 'USD',
    billingCurrencyCode: 'USD',
    allowCategorizationEnum: 'FORBIDDEN',
    locationKey: 'Baumbach-Baumbach',
    locationDetails: {
      locationKey: 'Baumbach-Baumbach',
      name: 'Baumbach-Baumbach',
      type: [],
      latitude: 0,
      longitude: 0,
    },
    categoryDetails: {},
    details: 'Baumbach-Baumbach',
    trxType: 'UNKNOW',
    trxTypeParams: 'NONE',
    allowComment: true,
    onHold: false,
    transactionStatus: TransactionStatus.SETTLED,
    externalTransactionType: ExternalTransactionTypes.SWIPE_REFUND,
    categorizationType: TransactionCategorizationType.INCOME,
  },
  // Receipt preview mock USE **webapp3@lili.co**
  {
    creditCard: false,
    activityTypeCode: 'AD',
    amount: -5,
    merchantName: 'Payment to Plaid Saving',
    currencyCode: 'USD',
    timestamp: '2024-02-18T11:34:40.000Z',
    transactionId: '392775_491072_AD',
    pending: false,
    type: 'S',
    sourceId: '491072',
    localCurrencyCode: 'USD',
    settleCurrencyCode: 'USD',
    billingCurrencyCode: 'USD',
    allowCategorizationEnum: 'READ_WRITE',
    locationKey: 'Payment to Plaid Saving',
    categoryDetails: {
      receiptPath: '51caa072-e6cc-4cc4-a9b9-5e40ea3d17a2',
    },
    details: 'Payment to Plaid Saving',
    trxType: 'ACH',
    trxTypeParams: 'NONE',
    allowComment: true,
    onHold: false,
    transactionStatus: TransactionStatus.SETTLED,
    externalTransactionType: ExternalTransactionTypes.ACH_TRANSFER,
    categorizationType: TransactionCategorizationType.EXPENSE,
    initiatorFirstName: 'James',
    initiatorLastName: 'Lebron',
  },
  {
    creditCard: false,
    activityTypeCode: 'PM',
    amount: 25,
    merchantName: '',
    currencyCode: 'USD',
    timestamp: '2024-02-20T12:21:49.000Z',
    transactionId: '392775_89940_URBN',
    pending: true,
    type: 'OR',
    localCurrencyCode: 'USD',
    settleCurrencyCode: 'USD',
    billingCurrencyCode: 'USD',
    allowCategorizationEnum: 'FORBIDDEN',
    categoryDetails: {},
    suggestedTaxCategoryId: '9d9e777d-9593-4b1a-b459-94fffced59b0',
    details: 'Check Deposit',
    trxType: 'CHECK_DEPOSIT',
    trxTypeParams: 'NONE',
    checkDetailsData: {
      checkTransactionId: '5f5ae9a1-7cbe-416b-b831-62221a5aafcf',
      status: TransactionCheckStatus.SEND,
      enteredAmount: '25.00',
      checkAccountNumber: '004631621236',
      checkNumber: '0242',
      estimatedArrivalDate: '2024-02-27T17:00:00.000+00:00',
    },
    allowComment: true,
    onHold: false,
    transactionStatus: TransactionStatus.PENDING,
    externalTransactionType: ExternalTransactionTypes.CHECK_DEPOSIT,
    categorizationType: TransactionCategorizationType.INCOME,
    initiatorFirstName: 'James',
    initiatorLastName: 'Lebron',
    sourceId: '',
  },
];
